/**
 * @constructor
 * @returns {MadnesControls}
 */
import {forcestopnow, set_forcestopnow, win_anim_skip_click} from "../../../framework/src/engine/madnes/madnes_variables";
import {madnes_win_anim_reset, madnes_win_anim_skip} from "../../../framework/src/engine/madnes/madnes";

export function MadnesControls() {};

/**
 * @returns {boolean}
 */
MadnesControls.prototype.isForceStop = function() {
    return !!forcestopnow;
};

MadnesControls.prototype.unsetForceStop = function() {
    set_forcestopnow(0);
};

MadnesControls.prototype.showSpin = function() {
    // madnes_show_spin();
};

MadnesControls.prototype.showStop = function() {
    // madnes_show_stop();
};

MadnesControls.prototype.hideStop = function() {
    // madnes_hide_stop();
};

MadnesControls.prototype.winAnimReset = function() {
    madnes_win_anim_reset();
};

MadnesControls.prototype.hideAllBtns = function() {
    // madnes_hide_btns();
};

MadnesControls.prototype.showAllBtns = function() {
    // madnes_show_btns();
};

MadnesControls.prototype.allBtnsHided = function() {
    // return madnes_hide_all_btns;
};

/** @returns {boolean} */
MadnesControls.prototype.winAnimSkip = function() {
    return madnes_win_anim_skip();
};

/** @returns {boolean} */
MadnesControls.prototype.winAnimSkipClicked = function() {
    return win_anim_skip_click > 0;
};